import { render, staticRenderFns } from "./CSlider.vue?vue&type=template&id=b745335c&scoped=true&"
import script from "./CSlider.vue?vue&type=script&lang=ts&"
export * from "./CSlider.vue?vue&type=script&lang=ts&"
import style0 from "./CSlider.vue?vue&type=style&index=0&id=b745335c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b745335c",
  null
  
)

component.options.__file = "CSlider.vue"
export default component.exports